import React from 'react';
import { Table } from 'reactstrap';
import { T } from '../traks';
import {dataPlaceholder, formatWithSeparators} from '../misc'

const getLink = () => {
    return "#";
}


export const FinancialData = (props) => {
const link = getLink();

const incomeStatementData = props.incomeStatement;
const balanceSheetData = props.balanceSheet;
const cashFlowData = props.cashFlow;

const getDataForYear = (dataSet, year, field) => {
    if (!dataSet) {
        return dataPlaceholder();
    }

    const data = dataSet[year] ? dataSet[year][field] : null;

    return typeof data === 'number' ? formatWithSeparators(data) : dataPlaceholder();
};

  return (
    <div className='py-4 px-3'>
    <div className="ad_financial_info">
      <div className='d-flex ad_company_info_card_header'>
          <h1 className='mt-3 ad_text_white'><T>Financial Statements</T></h1>
      </div>
      
      <div className='d-flex mt-4 ad_financial_info_heading'>
        <h5 className='mb-0 ad_text_black'><T>Annual Report</T></h5>
      </div>
      <div className="table-responsive-horizontal">
      <Table borderless size='sm' className='ad_financial_info_table'>
        <thead>
          <tr>
            <th><T>Year</T></th>
            <th>2023</th>
            <th>2022</th>
            <th>2021</th>
            <th>2020</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><T>Revenue</T></td>
            <td>{getDataForYear(incomeStatementData, '2023', 'Revenue')}</td>
            <td>{getDataForYear(incomeStatementData, '2022', 'Revenue')}</td>
            <td>{getDataForYear(incomeStatementData, '2021', 'Revenue')}</td>
            <td>{getDataForYear(incomeStatementData, '2020', 'Revenue')}</td>
          </tr>
          <tr>
            <td><T>Costs</T></td>
            <td>{getDataForYear(incomeStatementData, '2023', 'Costs')}</td>
            <td>{getDataForYear(incomeStatementData, '2022', 'Costs')}</td>
            <td>{getDataForYear(incomeStatementData, '2021', 'Costs')}</td>
            <td>{getDataForYear(incomeStatementData, '2020', 'Costs')}</td>
          </tr>
          <tr>
            <td><T>Gross Profit</T></td>
            <td>{getDataForYear(incomeStatementData, '2023', 'GrossProfit')}</td>
            <td>{getDataForYear(incomeStatementData, '2022', 'GrossProfit')}</td>
            <td>{getDataForYear(incomeStatementData, '2021', 'GrossProfit')}</td>
            <td>{getDataForYear(incomeStatementData, '2020', 'GrossProfit')}</td>
          </tr>
          <tr>
            <td><T>Operating Costs</T></td>
            <td>{getDataForYear(incomeStatementData, '2023', 'OperatingCosts')}</td>
            <td>{getDataForYear(incomeStatementData, '2022', 'OperatingCosts')}</td>
            <td>{getDataForYear(incomeStatementData, '2021', 'OperatingCosts')}</td>
            <td>{getDataForYear(incomeStatementData, '2020', 'OperatingCosts')}</td>
          </tr>
          <tr>
            <td><T>Operating Profit</T></td>
            <td>{getDataForYear(incomeStatementData, '2023', 'OperatingProfit')}</td>
            <td>{getDataForYear(incomeStatementData, '2022', 'OperatingProfit')}</td>
            <td>{getDataForYear(incomeStatementData, '2021', 'OperatingProfit')}</td>
            <td>{getDataForYear(incomeStatementData, '2020', 'OperatingProfit')}</td>
          </tr>
          <tr>
            <td><T>Profit Before Tax</T></td>
            <td>{getDataForYear(incomeStatementData, '2023', 'ProfitBeforeTax')}</td>
            <td>{getDataForYear(incomeStatementData, '2022', 'ProfitBeforeTax')}</td>
            <td>{getDataForYear(incomeStatementData, '2021', 'ProfitBeforeTax')}</td>
            <td>{getDataForYear(incomeStatementData, '2020', 'ProfitBeforeTax')}</td>
          </tr>
          <tr>
            <td><T>Profit After Tax</T></td>
            <td>{getDataForYear(incomeStatementData, '2023', 'ProfitAfterTax')}</td>
            <td>{getDataForYear(incomeStatementData, '2022', 'ProfitAfterTax')}</td>
            <td>{getDataForYear(incomeStatementData, '2021', 'ProfitAfterTax')}</td>
            <td>{getDataForYear(incomeStatementData, '2020', 'ProfitAfterTax')}</td>
          </tr>
        </tbody>
      </Table>
      </div>
      
      <div className='d-flex mt-4 ad_financial_info_heading'>
        <h5 className="mb-0 ad_text_black"><T>Balance sheet</T></h5>
      </div>
      <div className="table-responsive-horizontal">
      <Table borderless size='sm' className='ad_financial_info_table'>
        <thead>
          <tr>
            <th><T>Year</T></th>
            <th>2023</th>
            <th>2022</th>
            <th>2021</th>
            <th>2020</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><T>Fixed Assets</T></td>
            <td>{getDataForYear(balanceSheetData, '2023', 'FixedAssets')}</td>
            <td>{getDataForYear(balanceSheetData, '2022', 'FixedAssets')}</td>
            <td>{getDataForYear(balanceSheetData, '2021', 'FixedAssets')}</td>
            <td>{getDataForYear(balanceSheetData, '2020', 'FixedAssets')}</td>
          </tr>
          <tr>
            <td><T>Current Assets</T></td>
            <td>{getDataForYear(balanceSheetData, '2023', 'CurrentAssets')}</td>
            <td>{getDataForYear(balanceSheetData, '2022', 'CurrentAssets')}</td>
            <td>{getDataForYear(balanceSheetData, '2021', 'CurrentAssets')}</td>
            <td>{getDataForYear(balanceSheetData, '2020', 'CurrentAssets')}</td>
          </tr>
          <tr>
            <td><T>Inventory</T></td>
            <td>{getDataForYear(balanceSheetData, '2023', 'Inventory')}</td>
            <td>{getDataForYear(balanceSheetData, '2022', 'Inventory')}</td>
            <td>{getDataForYear(balanceSheetData, '2021', 'Inventory')}</td>
            <td>{getDataForYear(balanceSheetData, '2020', 'Inventory')}</td>
          </tr>
          <tr>
            <td><T>Equity</T></td>
            <td>{getDataForYear(balanceSheetData, '2023', 'Equity')}</td>
            <td>{getDataForYear(balanceSheetData, '2022', 'Equity')}</td>
            <td>{getDataForYear(balanceSheetData, '2021', 'Equity')}</td>
            <td>{getDataForYear(balanceSheetData, '2020', 'Equity')}</td>
          </tr>
          <tr>
            <td><T>Long-term Debt</T></td>
            <td>{getDataForYear(balanceSheetData, '2023', 'LongTermDebt')}</td>
            <td>{getDataForYear(balanceSheetData, '2022', 'LongTermDebt')}</td>
            <td>{getDataForYear(balanceSheetData, '2021', 'LongTermDebt')}</td>
            <td>{getDataForYear(balanceSheetData, '2020', 'LongTermDebt')}</td>
          </tr>
          <tr>
            <td><T>Short-term Debt</T></td>
            <td>{getDataForYear(balanceSheetData, '2023', 'ShortTermDebt')}</td>
            <td>{getDataForYear(balanceSheetData, '2022', 'ShortTermDebt')}</td>
            <td>{getDataForYear(balanceSheetData, '2021', 'ShortTermDebt')}</td>
            <td>{getDataForYear(balanceSheetData, '2020', 'ShortTermDebt')}</td>
          </tr>
        </tbody>
      </Table>
      </div>
      
      <div  className='d-flex mt-4 ad_financial_info_heading'>
        <h5 className="mb-0 ad_text_black"><T>Cashflow</T></h5>
      </div>
      <div className="table-responsive-horizontal">
      <Table borderless size='sm' className='ad_financial_info_table'>
        <thead>
          <tr>
            <th><T>Year</T></th>
            <th>2023</th>
            <th>2022</th>
            <th>2021</th>
            <th>2020</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><T>Cash Flow from Operations</T></td>
            <td>{getDataForYear(cashFlowData, '2023', 'OperatingCashFlow')}</td>
            <td>{getDataForYear(cashFlowData, '2022', 'OperatingCashFlow')}</td>
            <td>{getDataForYear(cashFlowData, '2021', 'OperatingCashFlow')}</td>
            <td>{getDataForYear(cashFlowData, '2020', 'OperatingCashFlow')}</td>
          </tr>
          <tr>
            <td><T>Cash Flow from Investments</T></td>
            <td>{getDataForYear(cashFlowData, '2023', 'InvestingCashFlow')}</td>
            <td>{getDataForYear(cashFlowData, '2022', 'InvestingCashFlow')}</td>
            <td>{getDataForYear(cashFlowData, '2021', 'InvestingCashFlow')}</td>
            <td>{getDataForYear(cashFlowData, '2020', 'InvestingCashFlow')}</td>
          </tr>
          <tr>
            <td><T>Cash Flow from Financing</T></td>
            <td>{getDataForYear(cashFlowData, '2023', 'FinancingCashFlow')}</td>
            <td>{getDataForYear(cashFlowData, '2022', 'FinancingCashFlow')}</td>
            <td>{getDataForYear(cashFlowData, '2021', 'FinancingCashFlow')}</td>
            <td>{getDataForYear(cashFlowData, '2020', 'FinancingCashFlow')}</td>
          </tr>
        </tbody>
      </Table>
      </div>
    </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/c/FinancialData.js